
import { computed, Ref } from 'vue';
import { useStore } from 'vuex';
import { Question } from 'altru-types';

export default {
  name: 'GuidelineOverlay',
  setup(): { guidelineImage: Ref<string | undefined> } {
    const store = useStore();
    const questionInfo: Ref<Question> = computed(() => store.getters['questions/questionInfo']);
    const guidelineImage: Ref<string | undefined> = computed(() => questionInfo.value.guideline_image_url);

    return {
      guidelineImage,
    };
  },
};
